export default __webpack_public_path__ + "images/audimatic_dash.jpg";